import type { ExtractPatchRoutes, RouteSegment } from '@openclassrooms/sdk';
import useMutationRequest from './useMutationRequest';
import type { ApiRoutes, PatchRequestBuilder, RequestOption, MutateOptions } from '../types';
export default function usePatch(path, mutationOptions) {
  return useMutationRequest("PATCH", path, mutationOptions);
}